import { LocalDate } from '@fcom/core/utils';
import { FinnairApisRequirementKeyEnum, FinnairCompletionStatus } from '@fcom/dapi/api/models';

import { EntryDocumentType, FinnairPassengerItemWithApis } from '../../check-in/interface/check-in.interface';

export const getFirstDefinedDateOrEmpty = (...dates: string[]): LocalDate | undefined => {
  const definedDate = dates.find((date) => !!date && LocalDate.isLocalDate(date));
  return definedDate ? new LocalDate(definedDate) : undefined;
};

export const isApisRequirementListCompleted = (passenger: FinnairPassengerItemWithApis): boolean => {
  return passenger.apisCpr?.requirements
    ?.filter((requirement) => requirement.required)
    .every((requirement) => requirement.status === FinnairCompletionStatus.COMPLETED);
};

export const getCompletedEntryDocumentType = (
  passenger: FinnairPassengerItemWithApis
): EntryDocumentType | undefined => {
  const entryDocumentRequirementKey: FinnairApisRequirementKeyEnum = passenger.apisCpr?.requirements?.find(
    (requirement) =>
      (requirement.key === FinnairApisRequirementKeyEnum.VISA ||
        requirement.key === FinnairApisRequirementKeyEnum.PERMANENT_RESIDENT_CARD) &&
      requirement.status === FinnairCompletionStatus.COMPLETED
  )?.key;
  return entryDocumentRequirementKey === FinnairApisRequirementKeyEnum.VISA
    ? EntryDocumentType.VISA
    : entryDocumentRequirementKey === FinnairApisRequirementKeyEnum.PERMANENT_RESIDENT_CARD
      ? EntryDocumentType.RESIDENT
      : undefined;
};
